
import React from "react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";

interface LoginRequiredDialogProps {
  isOpen: boolean;
  onClose: () => void;
  redirectUrl?: string;
  message?: string;
}

const LoginRequiredDialog = ({
  isOpen,
  onClose,
  redirectUrl = "",
  message = "Please log in to enroll in this course."
}: LoginRequiredDialogProps) => {
  // Save the redirect URL in localStorage so it can be retrieved after login
  const handleLogin = () => {
    if (redirectUrl) {
      localStorage.setItem('authRedirectUrl', redirectUrl);
    }
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="flex flex-col items-center">
          {/* Icon placed above the text */}
          <div className="rounded-full bg-[#F2FCE2] p-6 mb-6">
            <LogIn className="h-10 w-10 text-[#34BF49]" />
          </div>
          
          <DialogTitle className="text-2xl font-bold text-center">
            <span className="text-[#34BF49]">Login Required</span>
          </DialogTitle>
          <DialogDescription className="text-lg mt-2 text-center">
            {message}
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter className="sm:justify-center flex-col sm:flex-row gap-3 mt-6">
          <Button 
            variant="outline" 
            onClick={onClose}
            className="w-full sm:w-auto border-gray-300"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleLogin}
            className="w-full sm:w-auto bg-[#34BF49] hover:bg-[#2da940] text-white transition-all"
            asChild
          >
            <Link to="/login">Go to Login</Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LoginRequiredDialog;
